import React, { useState, useEffect } from 'react';
import './StoryTeller.css';

const stories = [
  { title: 'Who is the king?', content: 'There is a small forest. All the animals are hunted by the Hunter. All the animals are decided to make lion as king due to the hunters are afraid of lion. After the lion becomes king, start hunting and killing animals everyday. No animals protest or object the lion. The lion continues to kill the friends, siblings of animals. All the animals conducted a meeting and decided to trap the lion and kill it. Like that, all the animals trapped the lion and killed it. Next day, all the animals decided and make elephant as king to that small forest. Note: 1) Violence never work always. 2) First, to know whose side the king is… ', },
  { title: 'Never believe anyone blindly.', content: 'Mr. ‘E’ and Mr. ‘M’ are the best friends. They are very close friends, even the project at the final year assigned separate project works and they convince professors and work in same project. Mr. ‘M’ wants to become software Engineer and Mr. ‘E’ wants to become prestigious position in government. Sometime discussion goes on and it takes to days. At last, Mr. ‘E’ convince Mr. ‘E’ to become government officer in a big position. Next day onwards, Mr. ‘M’ focused on government exams and shared the collected and prepared data to Mr. ‘E’. One day suddenly Mr. ‘E’ told to Mr. ‘M’ that, I got an opportunity in Multi national company as software engineer. Mr. ‘M’ asked Mr. ‘E’ that, we did not plan like this and Mr. ‘E’ replied that, “ it happens in life and it is obvious thing and you need to change and never believe everything blindly…”. Note: Never believe anyone heartfully and blindly whoever it is…. ', },
  { title: 'Save the water and not to waste water', content: 'The water is the most precious element in the earth. Previous decades we had more water than required. As per scientific name of the water in a molecular formula is H2o. Normally, the water is in a liquid state and it is in a solid state in the form of ice and also it is in a gaseous state when the water is in stream. The water has no color and it is transparent and if your pour water in a vessel and it changes and adapt to that vessel. It is useful for drinking, cooking, gardening and so on. We can live without food for somedays but without water we can not live. The source of water is through rains,rivers, lakes and wells. Now the water is not adequate and for the next generation will face the water problems.', },
  { title: 'Live in Reality', content: 'There once was a shepherd boy who was bored. He has courage to face anything in this world. However, he has no ability to live in reality. He has always believed in supernatural things and super heroes. He lived in an illusion and all his friends are also teasing him for his behaviour and living in a trance.  At last, he lost his time, energy and life for nothing... And all his friends are well settled in their life. Finally, he understands that, believe in super powers are all trash and it is just for entertainment. The existing power in our self is much more enough to achieve anything what we want in reality. Note: 1) Not living in reality is also one kind of addiction just like smoking, drinking and so on...', },
  { title: 'The Lion and the Mouse', content: ' When a lion was resting in the jungle, a mouse began racing up and down his body for amusement. The lion’s sleep was interrupted, and he awoke enraged. The lion was going to eat the mouse when the mouse begged him to let him go. “I assure you, if you save me, I will be of immense help to you in the future.” The lion laughed at the mouse’s self-assurance and freed him.A group of hunters arrived in the forest one day and captured the lion. They had him tied to a tree. The lion began to roar as he struggled to get out. Soon, the mouse passed by and spotted the lion in distress. He dashed off, biting on the ropes to free the lion, and the two hurried off into the woods.   ', },
  { title: 'The telugu story', content: 'తాబేలును తిరిగేసి మూతిని దగ్గరగా పెట్టింది ఇలా నక్క తనని పరీక్షిస్తున్న ఎంతసేపు తాబేలు ప్రాణాలు అరచేతిలో పెట్టుకుని ఊపిరి బిగపట్టుకొని ఉన్నది.ఊపిరి బిగపట్టుకొని ఉన్నది ఇంతలో దానికి ఒక ఉపాయం తట్టింది. దాంతో ధైర్యం చేసి తలా కొంచెం బయట పెట్టింది అయ్యో నక్క బావ నువ్వు ఎన్ని తిప్పలు పడ్డా నా శరీరంలో ఇతర మాంస మైనా తినలేవు అంది తాబేలు.', },
  { title: 'Tables', content: '2 + 1= 3, 2+2=4, 2+3=5', },
  // Add more stories here...
];

const StoryTeller = () => {
    const [selectedStory, setSelectedStory] = useState(stories[0]);
    const [voices, setVoices] = useState([]);
    const [selectedVoice, setSelectedVoice] = useState(null);
    const [rate, setRate] = useState(0.8); // Slow rate

    useEffect(() => {
        const synth = window.speechSynthesis;
        const updateVoices = () => {
            const availableVoices = synth.getVoices();
            setVoices(availableVoices);
            if (availableVoices.length) {
                setSelectedVoice(availableVoices[0]);
            }
        };

        synth.onvoiceschanged = updateVoices;
        updateVoices();
    }, []);

    const handleVoiceChange = (e) => {
        setSelectedVoice(voices.find(voice => voice.name === e.target.value));
    };

    const handleStoryChange = (e) => {
        const selectedTitle = e.target.value;
        setSelectedStory(stories.find(story => story.title === selectedTitle));
    };

    const handleSpeak = () => {
        if (selectedStory && selectedVoice) {
            const utterance = new SpeechSynthesisUtterance(selectedStory.content);
            utterance.voice = selectedVoice;
            utterance.rate = rate;
            window.speechSynthesis.speak(utterance);
        }
    };

    return (
        <div className="AppStory">
            <h1>Story Teller</h1>
            Select story: &nbsp; &nbsp;

            <select onChange={handleStoryChange} value={selectedStory.title}>
                {stories.map((story, index) => (
                    <option key={index} value={story.title}>
                        {story.title}
                    </option>
                ))}
            </select>
            <br/>
            <textarea
                readOnly
                rows="100"
                cols="100"
                value={selectedStory.content}
            />
            <div className="controls">
                <label htmlFor="voice">Voice: </label>
                <select id="voice" onChange={handleVoiceChange} value={selectedVoice ? selectedVoice.name : ''}>
                    {voices.map((voice, index) => (
                        <option key={index} value={voice.name}>
                            {voice.name} ({voice.lang})
                        </option>
                    ))}
                </select>
                <label htmlFor="rate">Speed: </label>
                <input
                    type="range"
                    id="rate"
                    min="0.1"
                    max="2"
                    value={rate}
                    step="0.1"
                    onChange={(e) => setRate(e.target.value)}
                />
                <button onClick={handleSpeak}>Read Story</button>
            </div>
        </div>
    );
};

export default StoryTeller;
